// Start-up: read site.json, load the content and map files it lists, then build the report.
// All paths in site.json are relative to site.json itself, so the package works in any folder.
import { createApp } from './app.js';

var WFI = window.WFI = window.WFI || {};
WFI.plugins = WFI.plugins || [];
WFI.version = typeof __WFI_VERSION__ !== 'undefined' ? __WFI_VERSION__ : 'dev';

// A single-file build carries all JSON files inside the page: <script type="application/json" id="wf-files">.
var INLINE = null;
(function () { var n = document.getElementById('wf-files'); if (n) { try { INLINE = JSON.parse(n.textContent); } catch (e) { INLINE = null; } } })();
function bare(p) { return String(p).split('?')[0]; }
function getJSON(path, base) {
  if (INLINE && Object.prototype.hasOwnProperty.call(INLINE, bare(path))) return Promise.resolve(INLINE[bare(path)]);
  var url = new URL(path, base).href;
  return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status + ' ' + url); return r.json(); });
}
function fail(root, err) {
  if (window.console) console.error('Wind Fleet Insight could not start.', err);
  root.innerHTML = '<p class="wf-boot-error">The report could not be loaded. Please reload the page.</p>';
}

function boot() {
  var root = document.getElementById('wf-app'); if (!root) return;
  var tag = document.querySelector('script[data-wf-config]'), cfgPath = tag ? tag.getAttribute('data-wf-config') : 'site.json';
  var cfgUrl = new URL(cfgPath, document.baseURI).href;
  var site = WFI.site && WFI.site.config ? Promise.resolve(WFI.site.config) : getJSON(cfgPath, document.baseURI);
  if (WFI.site && WFI.site.url) cfgUrl = WFI.site.url;
  site.then(function (cfg) {
    function abs(p) { return /^(data:|https?:)/.test(p) ? p : new URL(p, cfgUrl).href; }
    var content = {}, map = {}, jobs = [];
    Object.keys(cfg.content).forEach(function (k) { jobs.push(getJSON(cfg.content[k], cfgUrl).then(function (v) { content[k] = v; })); });
    Object.keys(cfg.map).forEach(function (k) { jobs.push(getJSON(cfg.map[k], cfgUrl).then(function (v) { map[k] = v; })); });
    return Promise.all(jobs).then(function () {
      WFI.config = cfg;
      var lazy = {}; Object.keys(cfg.lazy || {}).forEach(function (k) { lazy[k] = { script: abs(cfg.lazy[k].script), css: cfg.lazy[k].css ? abs(cfg.lazy[k].css) : null }; });
      createApp(root, { content: content, map: map, lazy: lazy, weatherApi: cfg.weatherApi, brand: { logoDark: abs(cfg.brand.logoDark), logoLight: abs(cfg.brand.logoLight) } });
    });
  }).catch(function (e) { fail(root, e); });
}
boot();
